import { render, staticRenderFns } from "./ChemicalIsotope.vue?vue&type=template&id=29b16bd6&"
import script from "./ChemicalIsotope.vue?vue&type=script&lang=ts&"
export * from "./ChemicalIsotope.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports